// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_ShiftType_Accessory = require("./CommonTypes_ShiftType_Accessory.bs.js");

var Raw = {};

var query = "fragment CommonTypes_ShiftType_Accessories on ShiftType   {\naccessories  {\nnodes  {\n...CommonTypes_ShiftType_Accessory   \n}\n\n}\n\n}\n" + CommonTypes_ShiftType_Accessory.query;

function parse(value) {
  var value$1 = value.accessories;
  var value$2 = value$1.nodes;
  return {
          accessories: {
            nodes: value$2.map(function (value) {
                  if (!(value == null)) {
                    return CommonTypes_ShiftType_Accessory.verifyArgsAndParse("CommonTypes_ShiftType_Accessory", value);
                  }
                  
                })
          }
        };
}

function serialize(value) {
  var value$1 = value.accessories;
  var value$2 = value$1.nodes;
  var nodes = value$2.map(function (value) {
        if (value !== undefined) {
          return CommonTypes_ShiftType_Accessory.serialize(value);
        } else {
          return null;
        }
      });
  var accessories = {
    nodes: nodes
  };
  return {
          accessories: accessories
        };
}

function verifyArgsAndParse(_CommonTypes_ShiftType_Accessories, value) {
  return parse(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  return Curry._1(CommonTypes_ShiftType_Accessory.$$Set.fromArray, Relude_Array.mapOption(Relude_Globals.id, param.accessories.nodes));
}

exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
/* Relude_Array Not a pure module */
